var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoUsersGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.184,
    height: 43.08,
    viewBox: "0 0 63.184 43.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10545"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91640",
    d: "M324.956 266.632a10.77 10.77 0 1 0-11.88 0 17.245 17.245 0 0 0-11.291 16.155h2.872a14.36 14.36 0 0 1 28.72 0h2.872a17.245 17.245 0 0 0-11.293-16.155zm-13.838-8.975a7.9 7.9 0 1 1 7.9 7.9 7.907 7.907 0 0 1-7.9-7.9z",
    transform: "translate(-287.424 -239.707)",
    style: {
      fill: "#007aff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91641",
    d: "M356.417 253.952a10.759 10.759 0 1 0-15.2-14.441 13.682 13.682 0 0 1 2.539 1.345 7.948 7.948 0 0 1 1.928-2.139 7.884 7.884 0 1 1 4.8 14.157c-.254 0-.5-.015-.753-.039a13.562 13.562 0 0 1-.484 3c.411-.036.817-.088 1.236-.088a14.448 14.448 0 0 1 14.36 14.36h2.872a17.245 17.245 0 0 0-11.298-16.155z",
    transform: "translate(-304.525 -234.207)",
    style: {
      fill: "#f47a00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 91642",
    d: "M293.657 255.747c.42 0 .826.053 1.236.088a13.563 13.563 0 0 1-.484-3c-.248.024-.5.039-.753.039a7.893 7.893 0 1 1 6.726-12.018 13.7 13.7 0 0 1 2.539-1.345 10.761 10.761 0 1 0-15.2 14.441 17.246 17.246 0 0 0-11.292 16.155h2.871a14.448 14.448 0 0 1 14.36-14.36z",
    style: {
      fill: "#f47a00"
    },
    transform: "translate(-276.425 -234.207)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUsersGraphic);
export default __webpack_public_path__ + "static/media/no-users-graphic.svg";
export { ForwardRef as ReactComponent };